
export default function IndustriesServed(){

const industries=[
"Printing",
"Packaging",
];

return(

<section className="industries">

<h2>Industries We Serve</h2>

<div className="industry-list">

{industries.map((item,index)=>

<span key={index}>{item}</span>

)}

</div>

</section>

);

}
